import { BankIcon } from '@libs/components';

export default BankIcon;
